export default __webpack_public_path__ + "static/tozer-545d87caaa07701152a7155b278b6e63.jpg";